import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@istari-frontend/ui";
import { Save, Share2 } from "lucide-react";

import { ChatSaveTranscript } from "~/ai-chat/feature/chat-save-transcript";
import { ChatShareModal } from "~/ai-chat/feature/chat-share-modal";
import { useAiChat } from "~/ai-chat/feature/use-ai-chat";
import { useChatSaveShare } from "~/ai-chat/feature/use-chat-save-share";
import { chatWindowTitle } from "~/ai-chat/model/chat-window-title";

// The Save + Share toolbar buttons and their dialogs, shared by the floating widget and the full-page chat
// so the wiring lives in one place. The dialogs are portaled, so this can render anywhere in a toolbar.
export function ChatSaveShareControls() {
  const { messages, chatTitle, newChatPending } = useAiChat();
  const saveShare = useChatSaveShare();
  // Disabled until the first send binds a conversation: before then `activeConversationId` is null, so a
  // save can't link the transcript to the conversation and a later Share would duplicate it after a reload.
  const canSaveOrShare = messages.some((item) => item.kind === "message") && !newChatPending;
  const defaultName = chatTitle ?? chatWindowTitle(messages);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="xs"
            className="px-1.5"
            onClick={saveShare.openSaveDialog}
            disabled={!canSaveOrShare}
            aria-label="Save chat to your library"
          >
            <Save className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">Save chat to your library</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="xs"
            className="px-1.5"
            onClick={saveShare.openShareModal}
            disabled={!canSaveOrShare}
            aria-label="Share chat"
          >
            <Share2 className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">Share chat</TooltipContent>
      </Tooltip>
      {saveShare.saveDialogOpen && (
        <ChatSaveTranscript messages={messages} defaultName={defaultName} onClose={saveShare.closeSaveDialog} />
      )}
      {saveShare.shareModalOpen && (
        <ChatShareModal
          messages={messages}
          defaultName={defaultName}
          initialResourceId={saveShare.shareInitialResourceId}
          onClose={saveShare.closeShareModal}
        />
      )}
    </>
  );
}
